
import React, { useState, useEffect } from 'react';

import { Row, Col, Divider, Spin } from 'antd';


// import 'antd/dist/antd.css';
import './index.css';

// import LoadingModal from './components/LoadingModal';
import UploadImage from './components/UploadImage';
import AdvancedOptions from './components/AdvancedOptions';
import MainCanvas from './components/MainCanvas';
import ColorPalette from './components/ColorPalette';
import Submit from './components/Submit';
import ColorPreview from './components/ColorPreview';
import CropImage from './components/CropImage';
import TopBar from './components/TopBar';







const ImageToSvg = (props) => {

    const [file, setFile] = useState("")
    const [colors, setColors] = useState([])
    const [clickedColor, setClickedColor] = useState("")
    const [isLoading, setIsLoading] = useState(false)
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [isCropVisible, setIsCropVisible] = useState(false)
    const [downloadSVGLink, setDownloadSVGLink] = useState('')
    const [shareLink, setShareLink] = useState('')
    const [smoothness, setSmoothness] = useState(1)
    const [despeckle, setDespeckle] = useState(10)
    const [simplifyCurves, setSimplifyCurves] = useState(0.2)
    const [imageDimensions, setImageDimensions] = useState([0, 0])
    const [scale, setScale] = useState(1)
    const [largeImageWarning, setLargeImageWarning] = useState(false)

    const [crop, setCrop] = useState({
        unit: 'px', // Can be 'px' or '%'
        x: null,
        y: null,
        width: null,
        height: null
      })


    const [screenSize, getDimension] = useState({
        dynamicWidth: window.innerWidth,
        dynamicHeight: window.innerHeight
    });

    const setDimension = () => {
        getDimension({
            dynamicWidth: window.innerWidth,
            dynamicHeight: window.innerHeight
        })
    }


    useEffect(() => {
        window.addEventListener('resize', setDimension);

        return (() => {
            window.removeEventListener('resize', setDimension);
        })
    }, [screenSize])



    // is your image black and white? multicolor?
    if (screenSize.dynamicWidth < 750) {
        return (
            <div>


                {file === "" &&
                    <div style={{ height: 'calc(100vh - 30px)' }}>
                        <UploadImage setCrop={setCrop} setLargeImageWarning={setLargeImageWarning} setDespeckle={setDespeckle} setScale={setScale} setImageDimensions={setImageDimensions} setFile={setFile} setColors={setColors} />
                    </div>
                }
                {file != "" &&
                    <div>
                        <Spin tip="Loading..." spinning={isLoading}>
                        <Row justify="space-between" style={{margin: "10px"}}>
                            <ColorPreview />
                        </Row>

                        <Row>
                            <Col flex="auto" style={{ maxWidth: 'calc(100%)' }}>
                            <TopBar scale={scale} setScale={setScale} file={file} setFile={setFile} crop={crop} setIsCropVisible={setIsCropVisible}/>
                                <MainCanvas crop={crop} setFile={setFile} file = {file} scale={scale} setScale={setScale} setClickedColor={setClickedColor} />
                            </Col>
                        </Row>


                        
                        <Divider style={{ margin: '0px', marginTop: '10px' }} />
                        <Row  >
                            <Col span={24} >
                            <ColorPalette colors={colors} setColors={setColors} clickedColor={clickedColor}file={file}  />
                            </Col>
                            <Col span={24} >
                            {/* <AdvancedOptions imageDimensions={imageDimensions} setSmoothness={setSmoothness} setDespeckle={setDespeckle} despeckle={despeckle} setSimplifyCurves={setSimplifyCurves} /> */}
                            </Col>
                            <Col span={24} >
                            <Divider style={{ margin: '0px', marginTop: '10px', marginBottom: '10px' }} />
                            </Col>
                            <Col span={24}><Submit setRawSvg={props.setRawSvg} crop={crop} despeckle={despeckle} simplifyCurves={simplifyCurves} smoothness={smoothness} colors={colors} file={file} setIsLoading={setIsLoading} setDownloadSVGLink={setDownloadSVGLink} setShareLink={setShareLink} setIsModalVisible={setIsModalVisible} /></Col>
                           
                        </Row>
                        <CropImage setScale={setScale} setImageDimensions={setImageDimensions} cropGlobal={crop} setCropGlobal={setCrop} largeImageWarning={largeImageWarning} file={file} isModalVisible={isCropVisible} setIsModalVisible={setIsCropVisible} downloadSVGLink={downloadSVGLink} isLoading={isLoading} />
                                
                        {/* <ResultsModal largeImageWarning={largeImageWarning} isModalVisible={isModalVisible} setIsModalVisible={setIsModalVisible} downloadSVGLink={downloadSVGLink} shareLink={shareLink} isLoading={isLoading} /> */}
                        </Spin>
                    </div>

                }
            </div>
        )

    }
    else {
        return (
            <div>

                {file === "" &&
                    <div style={{ height: '60vh' }}>
                        <UploadImage  setCrop={setCrop} setLargeImageWarning={setLargeImageWarning} setScale={setScale} setDespeckle={setDespeckle} setImageDimensions={setImageDimensions} setFile={setFile} setColors={setColors} />
                    </div>
                }
                {file != "" &&
                    <div>                        
                        <Spin tip="Loading..." spinning={isLoading}>
                        <Row style={{ outline: "1px solid #f0f0f0", minWidth: "500px" }}>


                            <Col flex="auto" style={{ maxWidth: 'calc(100% - 260px)' }}>
                                <TopBar scale={scale} setScale={setScale} file={file} setFile={setFile} crop={crop} setIsCropVisible={setIsCropVisible}/>
                                <MainCanvas setClickedColor={setClickedColor} />
                            </Col>
                            <Col flex="240px" style={{ margin: '10px', height: '60vh' }}>
                                <ColorPreview />
                                <Divider style={{ margin: '0px', marginTop: '10px' }} />
                                <ColorPalette colors={colors} setColors={setColors} clickedColor={clickedColor} file={file} />
                                {/* <AdvancedOptions imageDimensions={imageDimensions} setSmoothness={setSmoothness} setDespeckle={setDespeckle} despeckle={despeckle} setSimplifyCurves={setSimplifyCurves} /> */}
                                <Divider style={{ margin: '0px', marginTop: '10px', marginBottom: '10px' }} />
                                <Row>
                                    <Col span={24}><Submit setRawSvgSvg={props.setRawSvg} crop={crop} despeckle={despeckle} simplifyCurves={simplifyCurves} smoothness={smoothness} colors={colors} file={file} setIsLoading={setIsLoading} setDownloadSVGLink={setDownloadSVGLink} setShareLink={setShareLink} setIsModalVisible={setIsModalVisible} /></Col>
                                </Row>
                                <CropImage setScale={setScale} setImageDimensions={setImageDimensions} cropGlobal={crop} setCropGlobal={setCrop} largeImageWarning={largeImageWarning} file={file} isModalVisible={isCropVisible} setIsModalVisible={setIsCropVisible} downloadSVGLink={downloadSVGLink} isLoading={isLoading} />
                                {/* <LoadingModal largeImageWarning={largeImageWarning} isModalVisible={isModalVisible} setIsModalVisible={setIsModalVisible} isLoading={isLoading} /> */}
                            </Col>

                        </Row>
                        </Spin>
                    </div>

                }

            </div>

        );
    }
}


export default ImageToSvg;